import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Marker, Popup } from 'react-leaflet';
import { MapContainer } from 'react-leaflet/MapContainer'
import { TileLayer } from 'react-leaflet/TileLayer'
import L from 'leaflet';
import { NotSwapComponent } from '../Redux/actions';

const Location = () => {
    const dispatch = useDispatch()
    const { locations, loading } = useSelector((Store) => Store)
    // console.log(places)
    // const {country,places}=alter
    console.log(locations)
    const customIcon = new L.Icon({
        iconUrl: 'https://cdn-icons-png.flaticon.com/128/684/684908.png', // Path to the custom marker image
        iconSize: [32, 32], // Size of the icon
        iconAnchor: [16, 32], // Anchor point of the icon (relative to its size)
        popupAnchor: [0, -32], // Popup anchor point (relative to its size)
    });
    const handleSwap = () => {
        dispatch(NotSwapComponent())
    }
    return (
        <div>
            {loading ? <div className='w-full h-[92vh] flex items-center justify-center'>
                <div id="wifi-loader">
                    <svg class="circle-outer" viewBox="0 0 86 86">
                        <circle class="back" cx="43" cy="43" r="40"></circle>
                        <circle class="front" cx="43" cy="43" r="40"></circle>
                        <circle class="new" cx="43" cy="43" r="40"></circle>
                    </svg>
                    <svg class="circle-middle" viewBox="0 0 60 60">
                        <circle class="back" cx="30" cy="30" r="27"></circle>
                        <circle class="front" cx="30" cy="30" r="27"></circle>
                    </svg>
                    <svg class="circle-inner" viewBox="0 0 34 34">
                        <circle class="back" cx="17" cy="17" r="14"></circle>
                        <circle class="front" cx="17" cy="17" r="14"></circle>
                    </svg>
                    <div class="text">Loading...</div>
                </div>
            </div> : <div>
                <div className='flex py-1 w-full px-2 md:h-[6vh] justify-normal sm:justify-between sm:flex-row flex-col items-center'>
                    <div className='w-full sm:w-[100px]'>
                    <button onClick={handleSwap} className='bg-gray-900  w-[100px] rounded p-2 font-bold text-white'>Back</button>
                    </div>
                    <div className=' flex w-full sm:w-[80%] flex-col sm:flex-row justify-start sm:justify-around sm:items-center items-left' >
                        <p className='text-gray-900  font-bold'>Country: {locations?.country}</p>
                        <p className='text-gray-900  font-bold'>State: {locations?.places[0]?.state}</p>
                        <p className='text-gray-900  font-bold'>Place Name: {locations?.places[0]?.["place name"]}</p>
                    </div>
                </div>
                <div style={{ width: "100%", height: "86vh", overflow: 'hidden' }}>
                    <MapContainer center={{ lat: locations?.places[0]?.latitude, lng: locations?.places[0]?.longitude }} zoom={10} style={{ height: '100%', width: '100%' }}>
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?lang=en"
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        />

                        <Marker position={{ lat: locations?.places[0]?.latitude, lng: locations?.places[0]?.longitude }} icon={customIcon}>
                            <Popup>
                                <p>{locations?.places[0]["place name"]}</p>
                            </Popup>
                        </Marker>


                    </MapContainer>
                </div>
            </div>}

        </div>
    );
};

export default Location;
